<template>
  <div class="gallery-swpie-wrapper">
    <input
      class="change-image"
      id="imageUpload2"
      ref="fileInput"
      type="file"
      name="profile_photo"
      accept="image/*"
      @change="croppie"
    />

    <div class="add-photo" @click="trigger(images.filter((i) => i).length)">
      <div class="row">
        <v-icon>add_photo_alternate</v-icon>
      </div>
    </div>

    <div
      v-for="(image, i) in images.filter((i) => i)"
      :key="`image-${i}`"
      :style="{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundImage: 'url(' + image + ')',
      }"
      class="placeholder-pic placeholder-pic-edit border-black"
      @click="trigger(i)"
    >
      <div class="row">
        <v-icon class="update-image" color="white">photo</v-icon>
        <v-icon
          class="delete-image"
          @click.stop="
            photoToDelete = i;
            deleteDialog = true;
          "
          color="white"
          >delete</v-icon
        >
      </div>
    </div>

    <CroppieDialog
      ref="croppieDialog"
      :image="imageSrc"
      :show.sync="showCroppie"
      :circle="false"
      :gallery="true"
      @upload="cropGalleryOrProfilPhoto(true)"
    />

    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card class="dialog">
        <v-card-title class="headline text-xs-left">Bild löschen</v-card-title>

        <v-card-text class="text-xs-left">
          Möchtest du das Bild löschen?
          <b>Bist du dir sicher?</b>
        </v-card-text>

        <v-card-actions style="justify-content: center">
          <v-btn text @click="deleteDialog = false">Abbrechen</v-btn>
          <v-btn color="red white--text" text @click="deletePicture">Ja</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CroppieDialog from '../dialogs/CroppieDialog';
import croppieMixin from '../../mixins/croppie';

export default {
  name: 'set-images',

  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      deleteDialog: false,
      photoToDelete: null,
    };
  },

  mixins: [croppieMixin],

  components: {
    CroppieDialog,
  },

  computed: {
    // not updating after prop images changed
    localImages() {
      return this.images.filter((i) => i);
    },
  },

  // watch: {
  //   images: {
  //     handler(newValue) {
  //       console.log(newValue);
  //       this.localImages = newValue.filter(i => i);
  //     },
  //     immediate: true,
  //   },
  // },

  created() {
    // filter out old savings without link to image > it was always 4 items saved in array, with no links too
    // this.localImages = this.images.filter(i => i);
  },

  methods: {
    trigger(img) {
      console.log({ img });
      this.galleryImg = img;
      this.$refs.fileInput.click();
    },

    deletePicture() {
      this.$emit('delete-picture', +this.photoToDelete);
      this.deleteDialog = false;
    },
  },
};
</script>
